/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Limits applied to the shipment as a whole (sum across all line items).
 * @export
 * @interface ShipmentLimitsShipment
 */
export interface ShipmentLimitsShipment {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsShipment
     */
    minWeightPounds: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsShipment
     */
    maxWeightPounds: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsShipment
     */
    maxTotalVolumeCubicInches: number;
    /**
     * Maximum total number of handling units across all line items.
     * @type {number}
     * @memberof ShipmentLimitsShipment
     */
    maxHandlingUnits: number;
    /**
     * Maximum number of line items on a shipment.
     * @type {number}
     * @memberof ShipmentLimitsShipment
     */
    maxLineItems: number;
}

/**
 * Check if a given object implements the ShipmentLimitsShipment interface.
 */
export function instanceOfShipmentLimitsShipment(value: object): value is ShipmentLimitsShipment {
    if (!('minWeightPounds' in value) || value['minWeightPounds'] === undefined) return false;
    if (!('maxWeightPounds' in value) || value['maxWeightPounds'] === undefined) return false;
    if (!('maxTotalVolumeCubicInches' in value) || value['maxTotalVolumeCubicInches'] === undefined) return false;
    if (!('maxHandlingUnits' in value) || value['maxHandlingUnits'] === undefined) return false;
    if (!('maxLineItems' in value) || value['maxLineItems'] === undefined) return false;
    return true;
}

export function ShipmentLimitsShipmentFromJSON(json: any): ShipmentLimitsShipment {
    return ShipmentLimitsShipmentFromJSONTyped(json, false);
}

export function ShipmentLimitsShipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsShipment {
    if (json == null) {
        return json;
    }
    return {
        
        'minWeightPounds': json['minWeightPounds'],
        'maxWeightPounds': json['maxWeightPounds'],
        'maxTotalVolumeCubicInches': json['maxTotalVolumeCubicInches'],
        'maxHandlingUnits': json['maxHandlingUnits'],
        'maxLineItems': json['maxLineItems'],
    };
}

  export function ShipmentLimitsShipmentToJSON(json: any): ShipmentLimitsShipment {
      return ShipmentLimitsShipmentToJSONTyped(json, false);
  }

  export function ShipmentLimitsShipmentToJSONTyped(value?: ShipmentLimitsShipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minWeightPounds': value['minWeightPounds'],
        'maxWeightPounds': value['maxWeightPounds'],
        'maxTotalVolumeCubicInches': value['maxTotalVolumeCubicInches'],
        'maxHandlingUnits': value['maxHandlingUnits'],
        'maxLineItems': value['maxLineItems'],
    };
}

